import React from "react";
import { formatAmount } from "utils/amounts";
import { useLocation } from "hooks";

import {
  Container,
  FlixxCoin
} from './styles'
import { useGetBalance } from "api/user";

const FlixxBalanceMobile = () => {

  const { isCreators } = useLocation()
  const { data: amount } = useGetBalance()
  const balance = formatAmount(amount)

  return (
    <Container
      $isCreators={isCreators}
      to='/flixx'
    >
      <FlixxCoin />
      {balance}
    </Container>
  );
};

export default FlixxBalanceMobile;
